<template>
<div >
    <v-toolbar flat color="white">
        <v-btn color="primary" dark class="mb-2" @click="newDialog=true; basicInformation=true; showAccessPoints=false; cancelFields()" round >ADD ACCESS DEVICE</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    
    </v-toolbar>

     <v-dialog persistent v-model="singleSelectDeviceSearch" width="80vw">
            <v-card>
                <v-toolbar flat class="primary">
                    <h1 class="headline white--text">SEARCH DEVICES</h1>
                </v-toolbar>
                <v-card-text>
                    <v-layout wrap>
                        <v-text-field v-model="search2"
                                      append-icon="search"
                                      label="Search"
                                      single-line
                                      hide-details
                                      max-width="50px"
                                      class="pa-3"
                                      clearable></v-text-field>
                    </v-layout>
                    <v-data-table v-model="selected"
                                  :headers="deviceSearchHeaders"
                                  :items="allDevices"
                                  :pagination.sync="pagination"
                                  select-all
                                  :search="search2"
                                  item-key="id"
                                  class="elevation-1">
                        <template v-slot:headers="props">
                            <tr>
                                <th>
                                   
                                </th>
                                <th v-for="header in props.headers"
                                    :key="header.text"
                                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                    @click="changeSort(header.value)">
                                    <v-icon small>arrow_upward</v-icon>
                                    {{ header.text }}
                                </th>
                            </tr>
                        </template>
                        <template v-slot:items="props">
                            <tr :active="props.selected" @click="props.selected = !props.selected">
                                <td>
                                                <v-checkbox :input-value="props.selected"
                                                primary
                                                @click="selected=[]"
                                                hide-details></v-checkbox>
                                </td>
                                 <td class="text-xs-center" v-if="props.item.locationId!==null">{{props.item.location.locationDescription}}</td>
          <td class="text-xs-center" v-else-if="props.item.locationNetworkId!==null">{{props.item.locationNetwork.name}}</td>
          <td class="text-xs-center" v-else-if="props.item.locationNodeId!==null">{{props.item.locationNode.name}}</td>
          <td class="text-xs-center" v-else></td>

          <td class="text-xs-center" v-if="props.item.deviceMakeModel!==null">{{props.item.deviceMakeModel.deviceType.name}}</td>
          <td class="text-xs-center" v-else></td>
          <td class="text-xs-center" v-if="props.item.deviceMakeModel!==null">{{props.item.deviceMakeModel.deviceMake.name}}</td>
          <td class="text-xs-center" v-else></td>
          <td class="text-xs-center" v-if="props.item.deviceMakeModel!==null">{{props.item.deviceMakeModel.name}}</td>
          <td class="text-xs-center" v-else></td>
          <td class="text-xs-center">{{props.item.systemName}}</td>
          <td class="text-xs-center">{{props.item.serialNumber}}</td>
          <td class="text-xs-center">{{props.item.ponMac}}</td>
          <td class="text-xs-center">{{props.item.macAddress}}</td>
          <td class="text-xs-center">{{props.item.ponNumerical}}</td>
          <td class="text-xs-center">{{props.item.productNumber}}</td>
          <td class="text-xs-center" v-if="props.item.upstreamDeviceId!==null">{{props.item.upstreamDevice.name}}</td>
        <td class="text-xs-center" v-else></td>
          <td class="text-xs-center">{{props.item.ponAddress}}</td>
          <td class="text-xs-center">{{props.item.ponId}}</td>
          <td class="text-xs-center">{{props.item.frame}}</td>
          <td class="text-xs-center">{{props.item.slot}}</td>
          <td class="text-xs-center">{{props.item.port}}</td>
          <td class="text-xs-center">{{props.item.note}}</td>
                            </tr>
                        </template>
                    </v-data-table>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                          <v-btn color="primary" round @click="singleSelectDeviceSearch=false; selected=[]">Cancel</v-btn>
                          <v-btn color="primary" round @click="checkDevice()">Done</v-btn>
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-dialog>



     <v-dialog persistent v-if="accessPointSearch" v-model="accessPointSearch" max-width="1000px">
      <accesspointsearchmodal
           @accessPointSelected="onAccessPointSelection"
             :multi="false"
             :preselected="selectedAccessPoints"
      ></accesspointsearchmodal>
    </v-dialog>


     <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">
      <v-card >
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD ACCESS DEVICE</h1>
        </v-toolbar>
      <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                 
             
        <v-flex xs12 sm6 md6 v-if="this.selected.length==0">                        
          <v-btn  color="primary" flat @click="singleSelectDeviceSearch=true; selected=[]" >Add Device</v-btn>
         </v-flex>
            
                        <v-flex v-if="this.selected.length>0" xs12 sm6 md6>
                  <v-text-field
                    v-model="selected[0].deviceMakeModel.name"
                    label="*Device Make Model Name"
                    readonly
                    persistent-hint
                  ></v-text-field>
             <v-btn v-if="this.selected.length>0" flat color="primary" @click="singleSelectDeviceSearch=true">Edit Device</v-btn>          

                </v-flex>
                  
  
             <v-flex xs12 sm6 md6 v-if="this.selectedAccessPoints.length==0">
              <v-btn  
                color="primary" flat
                @click="accessPointSearch=true ; selectedAccessPoints=[]"
              >Add Access Point</v-btn>
               </v-flex>

          
             <v-flex v-if="this.selectedAccessPoints.length>0" xs12 sm6 md6>
                  <v-text-field
                    v-model="selectedAccessPoints[0].name"
                    label="*Access Point"
                    readonly
                    persistent-hint
                  ></v-text-field>
             <v-btn v-if="this.selectedAccessPoints.length>0" flat color="primary" @click="accessPointSearch=true">Edit Access Point</v-btn>          

                </v-flex>

                  <v-flex xs12 sm12 md6>
                  <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                    :items="directions"
                    required
                    v-model="editedItem.directionId"
                    label="*Direction"
                  ></v-autocomplete>
                </v-flex>  

                 <v-flex xs12 sm6 md6>
                  <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                    class="text-xs-center pr-5 pl-3 pt-2"
                    :items="communicationProtocols"
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.communicationProtocolId"  
                    label="*Communication Protocol"
                    multiple></v-autocomplete>       
                </v-flex>             

           </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <small>*indicates required field</small>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="saveNew">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Edit Modal -->
    <v-dialog persistent v-model="dialog" max-width="750px">
    
          <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >EDIT ACCESS DEVICE</h1>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
                 
                  <v-flex v-if="this.selected.length>0" xs12 sm6 md6>
                  <v-text-field
                    v-model="selected[0].deviceMakeModel.name"
                    label="*Device Make Model Name"
                    readonly
                    persistent-hint
                  ></v-text-field>
             <v-btn v-if="this.selected.length>0" flat color="primary" @click="singleSelectDeviceSearch=true">Edit Device</v-btn>          

                </v-flex>

                  <v-flex v-if="this.selectedAccessPoints.length>0" xs12 sm6 md6>
                  <v-text-field
                    v-model="selectedAccessPoints[0].name"
                    label="*Access Point"
                    readonly
                    persistent-hint
                  ></v-text-field>
             <v-btn v-if="this.selectedAccessPoints.length>0" flat color="primary" @click="accessPointSearch=true">Edit Access Point</v-btn>          

                </v-flex>

              <v-flex xs12 sm12 md6>
                  <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="directions"
                    required
                    v-model="editedItem.directionId"
                    label="*Direction"
                  ></v-autocomplete>
                </v-flex>  

                 <v-flex xs12 sm6 md6>
                 <v-autocomplete
                    clearable
                    hide-no-data
                    flat
                    color="primary"
                    :items="communicationProtocols"
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.communicationProtocolId"  
                    label="*Communication Protocol"
                    multiple></v-autocomplete>       
                </v-flex> 

         </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <small>*indicates required field</small>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save" >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="accessDevices"
      :rows-per-page-items="[10, 25, 50, 100]"
      item-key="name"
      align-center
    >
      <template v-slot:items="props" >
        <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="editItem(props.item);basicInformation=true; showAccessPoints=false">edit</v-icon>
            <v-icon small @click="deleteItem(props.item.id)">delete</v-icon>
          </td>     
          <td class="text-xs-center">{{props.item.accessPoint.name}}</td>
          <td v-if="(props.item.direction) != null && (props.item.direction) == true" class="text-xs-center">IN</td>   
          <td v-if="(props.item.direction) != null && (props.item.direction) == false" class="text-xs-center">OUT</td>   
          <td v-if="(props.item.direction) == null" class="text-xs-center">No Direction</td>   
           <td class="text-xs-center" v-if="props.item.device.deviceMakeModel.id!==null">{{props.item.device.deviceMakeModel.name}}</td>
        <td class="text-xs-center" v-else></td> 

    
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->
    
    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
import AccessPointSearchModal from "@/components/AccessPointSearchModal.vue";
import DeviceSearchModal from "@/components/DeviceSearchModal.vue";
export default {
  props:["accessdevicescomponent",
         "accessdevicesinfo"],
  components: {
    accesspointsearchmodal: AccessPointSearchModal,
     devicesearchmodal: DeviceSearchModal
  },
  data() {
    return {
        singleSelectDeviceSearch:false,
      selected: [],
      search2: '',
      deviceSearchHeaders: [
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Type",
          align: "center",
          value: "deviceMakeModel.deviceType.name"
        },
        {
          text: "Make",
          align: "center",
          value: "deviceMakeModel.deviceMake.name"
        },
        {
          text: "Model",
          align: "center",
          value: "deviceMakeModel.name"
        },
        {
          text: "System Name",
          align: "center",
          value: "serialNumber"
        },
        {
          text: "Serial Number",
          align: "center",
          value: "serialNumber"
        },
        {
          text: "PON MAC",
          align: "center",
          value: "ponMac"
        },
        {
          text: "MAC Address",
          align: "center",
          value: "macAddress"
        },
        {
          text: "PON Numerical",
          align: "center",
          value: "ponNumerical"
        },
        {
          text: "Product Number",
          align: "center",
          value: "productNumber"
        },
        {
          text: "Upstream Device",
          align: "center",
          value: "upstreamDevice.name"
        },
        {
          text: "PON Address",
          align: "center",
          value: "ponAddress"
        },
        {
          text: "PON ID",
          align: "center",
          value: "ponId"
        },
        {
          text: "Frame",
          align: "center",
          value: "frame"
        },
        {
          text: "Slot",
          align: "center",
          value: "slot"
        },
        {
          text: "Port",
          align: "center",
          value: "slot"
        },
        {
          text: "Note",
          align: "center",
          value: "note"
        }

      ],
      allDevices:[],
       deviceSearch: false,
    directions: ['IN', 'OUT', 'IN & OUT'],
    communicationProtocols: [],
    showAccessPoints: false,
    basicInformation: false,
    selectedAccessPoints: [],
    accessPointSearch: false,
    showDetails: true,
    isloading:true,
    loading: false, 
    expand: false,
    search: "",
    dialog: false,
    newDialog: false,
    pagination: { },
    headers: [
            {
        text: "Action",
        align: "center"
      },
      {
        text: "Access Point",
        align: "center",
        value: "accessPoint"
      },
      {
        text: "Direction",
        align: "center",
        value: "direction"
      },
      {
          text: "Device Model Name",
          align: "center",
          value: "deviceMakeModel.name"
        },
    ],
     headers2: [
                    {
                        text: "Name",
                        align: "center",
                        value: "name"
                    },
                    {
                        text: "Description",
                        align: "center",
                        value: "description"
                    }
                ],
    accessDevices: [],
    accessPoints: [],
    devices: [],
    editedIndex: -1,
    editedItem: {
        name: "",
        description: "",
        accessPointId: null,
        communicationProtocolId: null,
        deviceId: null,
        directionId: null,
        direction: false,
        isDeleted: false
    },
    defaultItem: {
        name: "",
        description: "",
        accessPointId: null,
        communicationProtocolId: null,
        deviceId: null,
        directionId: null,
        direction: false,
        isDeleted: false
    },
  }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
      search(value){
       const route= {
        search: this.$route.search
      }
       if ((this.search)){      
        route.query = {search: this.search}        
      }
      this.$router.push(route)      
    
    },
    '$route.query':{
      immediate: true,
      async handler(value){
        this.accessPointGroups= await this.searchAccessDevices(value)
      }
    },
     '$route.query.search':{
      immediate: true,
      handler(value){
        this.search=value
      },
    }, 
    
  },
  created() {
    this.initialize();
  },
  methods: {
     onAccessPointSelection(e){
      this.selectedAccessPoints = e
      this.accessPointSearch = false
    },
    cancelFields(){
    this.selectedAccessPoints =[],
     this.selected=[],
    this.editedItem.communicationProtocolId=[],
    this.editedItem.name="",
    this.editedItem.description="",
    this.editedItem.deviceId=null,
    this.editedItem.directionId = ''    
    },
    checkDevice(){
                 let proceed = true
                if (this.selected.length==0) {
                    proceed = false
                    confirm("Please select a device.")
                }
                if (proceed == true) {                    
                  this.singleSelectDeviceSearch=false
                }
    },
     searchAccessDevices(search){
       this.isloading =true
      if(search.search!==""){      
        Api()
        .get('/accessDevices/getall',{
          params: {
          search: search.search,
         }
          })
        .then(response=>{
          this.accessDevices=response.data
          this.isloading =false
        })} 
      },
    fetchAccessDevices() {
        this.isloading =true
      Api()
        .get("/accessDevices/getall")
        .then(response => {
          this.accessDevices = response.data;
          this.isloading =false
        });
      
    },
      fetchAccessPoints() {
        this.isloading =true
      Api()
        .get("/accessPoints/getall")
        .then(response => {
          this.accessPoints = response.data;
          this.isloading =false
        });
      
    },
      fetchCommunicationProtocols() {
        this.isloading =true
      Api()
        .get("/communicationProtocols/getall")
        .then(response => {
          this.communicationProtocols = response.data;
          this.isloading =false
        });
      
    },
      fetchDevices() {
        this.isloading =true
      Api()
        .get('/devices/searchByType')
        .then(response => {
          this.allDevices = response.data;
          this.isloading =false
        });
      
    },
    initialize() {
       this.fetchAccessDevices();
       this.fetchAccessPoints();
       this.fetchDevices();
       this.fetchCommunicationProtocols();
    },
    editItem(item) {
      this.selected=[]
      this.selectedAccessPoints=[]
      this.editedIndex = this.accessDevices.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.communicationProtocolId = []
      this.dialog = true;
      this.selected.push(item.device)
      this.selectedAccessPoints.push(item.accessPoint)
       for(let i=0; i<item.accessDeviceCommunicationProtocols.length; i++){
           this.editedItem.communicationProtocolId.push(item.accessDeviceCommunicationProtocols[i].communicationProtocolId)
         }
      this.editedItem.directionId = ''
      if(this.editedItem.direction == true){
        this.editedItem.directionId = 'IN'
      }
      if(this.editedItem.direction == false){
        this.editedItem.directionId = "OUT"
      }
      if(this.editedItem.direction == null){
        this.editedItem.directionId = "IN & OUT"
      }
    },
      deleteItem(id) {
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/accessDevices/" + id, {
          isDeleted: true
        }).then(response => {
            this.fetchAccessDevices();
        })
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
      changeSort(column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column
                    this.pagination.descending = false
                }
            },
    save() {
      let accessDevCommProtocolList = this.editedItem.accessDeviceCommunicationProtocols
      let communicationProtocolList = this.editedItem.communicationProtocolId
      let accessDevId = this.editedItem.id
       let proceed = true;
           if (typeof(this.selected[0]) == 'undefined') {
        proceed = false;
        confirm("Please select a device.");
      }   
      if (typeof(this.selectedAccessPoints[0]) == 'undefined') {
        proceed = false;
        confirm("Please select an access point.");
      }    
      if (communicationProtocolList.length == 0) {
        proceed = false;
        confirm("Please select a communication protocol.");
      }
      if(this.editedItem.directionId == 'IN'){
        this.editedItem.direction = true
      }else if(this.editedItem.directionId == 'OUT'){
        this.editedItem.direction = false
      }else{
        this.editedItem.direction = null
      }
      if (proceed == true) {     
        Api().put("/accessDevices/" + this.editedItem.id, {
          accessPointId:this.selectedAccessPoints[0].id,
          deviceId: this.editedItem.deviceId,
          direction: this.editedItem.direction,       
          isDeleted: this.editedItem.isDeleted
        }).then(response=>{
          for(let i=0; i<accessDevCommProtocolList.length; i++){
          Api().put("/accessDeviceCommunicationProtocols/" + accessDevCommProtocolList[i].id, {    
          isDeleted: true
        })
          }
        }).then(response=>{
           for(let j=0; j<communicationProtocolList.length; j++){
          Api().post("/accessDeviceCommunicationProtocols/", {
          accessDeviceId:accessDevId,
          communicationProtocolId: communicationProtocolList[j],      
          isDeleted: false
        })
            this.fetchAccessDevices();  }
        })
        this.close();
       }
      },
      saveNew() {
      let communicationProtocolList = this.editedItem.communicationProtocolId
      let proceed = true;
        if (typeof(this.selected[0]) == 'undefined') {
        proceed = false;
        confirm("Please select a device.");
      }   
      if (typeof(this.selectedAccessPoints[0]) == 'undefined') {
        proceed = false;
        confirm("Please select an access point.");
      }    
      if (communicationProtocolList.length == 0) {
        proceed = false;
        confirm("Please select a communication protocol.");
      }
      if(this.editedItem.directionId == 'IN'){
        this.editedItem.direction = true
      }else if(this.editedItem.directionId == 'OUT'){
        this.editedItem.direction = false
      }else{
        this.editedItem.direction = null
      }
      if (proceed == true) {
        Api().post("/accessDevices", {  
          accessPointId:this.selectedAccessPoints[0].id,
          deviceId: this.selected[0].id,
          direction: this.editedItem.direction,       
          isDeleted: this.editedItem.isDeleted
        }).then(response => {
             let accessDevId = response.data.id
         
         Api().delete("/accessDeviceCommunicationProtocols/deleteByValue")
        
            for(let i=0; i<communicationProtocolList.length; i++){
             Api()
        .post("/accessDeviceCommunicationProtocols", {
          accessDeviceId: accessDevId,
          communicationProtocolId: communicationProtocolList[i]
        }).then(response=>{
         this.fetchAccessDevices(); })
         }
        })
        this.close();
    }
  }
  }
};
</script>